export default __webpack_public_path__ + "static/media/Screenshot2.489d446c.png";